import { IconButton, Theme, Tooltip } from '@mui/material';
import React, { useContext } from 'react';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import MenuOpenRoundedIcon from '@mui/icons-material/MenuOpenRounded';
import NavContext from '../../contexts/NavContext';

const toggleNavSx = (theme: Theme) => ({
  fontSize: theme.spacing(3),
  // Media Queries
  [theme.breakpoints.up('sm')]: {
    fontSize: theme.spacing(4),
  },
});

const ToggleNav = () => {
  const { navOpen, setNav, toggleNav } = useContext(NavContext);
  const handleToggle = () => {
    toggleNav();
    setNav(!navOpen);
  };

  return (
    <Tooltip title={`${!navOpen ? 'Open Menu' : 'Close Menu'}`} placement="bottom-start">
      <IconButton
        onClick={handleToggle}
        edge="start"
        color="inherit"
        aria-label="toggle-menu"
        sx={toggleNavSx}
        size="large"
      >
        {/* Toggle Menu Icon based on state */}
        {navOpen === false ? (
          <MenuRoundedIcon
            data-testid="menuIcon-closed"
            sx={toggleNavSx}
          />
        ) : (
          <MenuOpenRoundedIcon
            data-testid="menuIcon-open"
            sx={toggleNavSx}
          />
        )}
      </IconButton>
    </Tooltip>
  );
};

export default ToggleNav;
